document.documentElement.classList.remove('no-js');

let drawerTrigger = null;
let searchTrigger = null;

const getFocusable = (container) => Array.from(container?.querySelectorAll(
  'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), details > summary, [tabindex]:not([tabindex="-1"])'
) || []).filter((element) => !element.hidden && element.getClientRects().length);

const revealLayer = (element) => {
  if (!element) return;
  element.hidden = false;
  window.requestAnimationFrame(() => element.classList.add('is-open'));
};

const hideLayer = (element, delay = 300) => {
  if (!element) return;
  element.classList.remove('is-open');
  window.setTimeout(() => {
    if (!element.classList.contains('is-open')) element.hidden = true;
  }, delay);
};

const setDrawer = (open) => {
  const drawer = document.querySelector('[data-mobile-drawer]');
  const backdrop = document.querySelector('[data-drawer-backdrop]');
  if (!drawer || !backdrop) return;
  const toggle = document.querySelector('[data-menu-toggle]');
  toggle?.setAttribute('aria-expanded', String(open));
  drawer.setAttribute('aria-hidden', String(!open));
  if (open) {
    drawerTrigger = document.activeElement;
    revealLayer(backdrop);
    revealLayer(drawer);
    document.body.classList.add('drawer-open');
    window.setTimeout(() => drawer.focus(), 30);
  } else {
    hideLayer(drawer);
    hideLayer(backdrop);
    if (document.querySelector('[data-search-overlay].is-open') === null) document.body.classList.remove('drawer-open');
    if (drawerTrigger instanceof HTMLElement) drawerTrigger.focus();
    drawerTrigger = null;
  }
};

const setSearch = (open) => {
  const dialog = document.querySelector('[data-search-overlay]');
  if (!dialog) return;
  const toggles = document.querySelectorAll('[data-search-open]');
  toggles.forEach((toggle) => toggle.setAttribute('aria-expanded', String(open)));
  dialog.setAttribute('aria-hidden', String(!open));
  if (open) {
    searchTrigger = document.activeElement;
    revealLayer(dialog);
    document.body.classList.add('drawer-open');
    window.setTimeout(() => dialog.querySelector('input')?.focus(), 30);
  } else {
    hideLayer(dialog, 230);
    if (document.querySelector('[data-mobile-drawer].is-open') === null) document.body.classList.remove('drawer-open');
    if (searchTrigger instanceof HTMLElement) searchTrigger.focus();
    searchTrigger = null;
  }
};

document.addEventListener('click', (event) => {
  if (event.target.closest('[data-menu-toggle]')) setDrawer(true);
  if (event.target.closest('[data-drawer-close], [data-drawer-backdrop]')) setDrawer(false);
  if (event.target.closest('[data-search-open]')) setSearch(true);
  if (event.target.closest('[data-search-close]')) setSearch(false);
  if (event.target.matches('[data-search-overlay]')) setSearch(false);
  const quantityButton = event.target.closest('[data-quantity-change]');
  if (quantityButton) {
    const input = quantityButton.parentElement.querySelector('input[type="number"]');
    if (!input) return;
    const direction = Number(quantityButton.dataset.quantityChange);
    input.value = Math.max(Number(input.min || 0), Number(input.value || 0) + direction);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    if (document.querySelector('[data-search-overlay].is-open')) setSearch(false);
    else if (document.querySelector('[data-mobile-drawer].is-open')) setDrawer(false);
  }
  if (event.key === 'Tab') {
    const activeLayer = document.querySelector('[data-search-overlay].is-open, [data-mobile-drawer].is-open');
    if (!activeLayer) return;
    const focusable = getFocusable(activeLayer);
    if (!focusable.length) {
      event.preventDefault();
      activeLayer.focus();
      return;
    }
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }
});

const header = document.querySelector('[data-site-header]');
if (header) {
  const updateHeader = () => header.classList.toggle('is-scrolled', window.scrollY > 16);
  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });
}
